import Vue from 'vue'
import Vuex from 'vuex'
import cookie from 'vue-cookie'

import auth from './auth.js'
import data from './data.js'
import tatib from './tatib.js'
import chartData from './chartData.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: cookie.get('token_operator_tatib'),
        errors: {},
        success: '',
        loading: true
    },
    mutations: {
        SET_TOKEN(state, payload) {
            state.token = payload
        },
        SET_ERRORS(state, payload) {
            state.errors = payload
        },
        CLEAR_ERRORS(state) {
            state.errors = {}
        },
        SET_SUCCESS(state, payload) {
            state.success = payload
        },
        CLEAR_SUCCESS(state) {
            state.success = ''
        },
        SET_LOADING(state) {
            state.loading = true
        },
        CLEAR_LOADING(state) {
            state.loading = false
        }
    },
    actions: {
        forceLogout({ state }) {
            state.token = null
            cookie.delete('token_operator_tatib')
        }
    },
    getters: {
        isAuth: state => {
            return state.token != "null" && state.token != null
        }
    },
    modules: {
        auth, 
        data, 
        tatib, 
        chartData,
    }
})